import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSouthKorea = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fillRule: "evenodd",
	clipRule: "evenodd",
	imageRendering: "optimizeQuality",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	viewBox: "0 0 512 512",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "nonzero",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 256,
				cy: 256,
				r: 256,
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("path", { d: "m106.5 203.8 40-59.8 9.9 6.7-39.9 59.8-10-6.7zm15 10 39.9-59.8 10 6.7-40 59.7-9.9-6.6zm15 10 39.8-59.8 10 6.6-39.9 59.8-10-6.6zM325.6 350l39.9-59.8 10 6.6-39.9 59.8-10-6.6zm15 10 39.8-59.9 10 6.7-39.9 59.7-10-6.6zm15 9.9 39.8-59.8 10 6.6-39.9 59.8-10-6.6z" }),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "m342.4 314.3 49.8 33.2-3.4 5-49.8-33.3z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CD2E3A",
				d: "M196.2 220.4a71.8 71.8 0 1 1 119.6 79.7l-119.6-79.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0047A0",
				d: "M196.2 220.4a71.9 71.9 0 0 0 119.6 79.7 36 36 0 1 0-59.8-39.8l-59.8-39.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#CD2E3A",
				d: "M246 210.5a35.9 35.9 0 1 0-39.8 59.7 35.9 35.9 0 0 0 39.8-59.7z"
			}),
			/* @__PURE__ */ _jsx("path", { d: "m146.4 376.5-39.9-59.8 10-6.6 39.9 59.8-10 6.6zm15-10-39.9-59.7 10-6.7 39.8 59.8-10 6.6zm14.9-10-39.9-59.7 10-6.6 39.9 59.8-10 6.6zm189.3-126.1-39.9-59.8 10-6.6 39.9 59.7-10 6.7zm15-10-40-59.8 10-6.6 39.9 59.8-10 6.6zm14.9-10-39.9-59.7 10-6.7 39.8 59.8-10 6.7z" }),
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "m137.3 335.8 15-10 3.2 5-15 10-3.2-5zM339 201.3l17.5-11.6 3.3 5-17.5 11.6-3.3-5zm32.4-21.6 15-10 3.3 5-15 10-3.3-5z"
			})
		]
	})
});
export default SvgSouthKorea;
